/**
 * beacon-utils.js — small helpers shared by widget screens/rows
 * (ConversationRow, HomeScreen "Korábbi beszélgetések" preview).
 */

import { t } from './beacon-i18n.js'

export function formatRelativeTime(iso) {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const diffMs = Date.now() - date.getTime()
  const diffMin = Math.round(diffMs / 60000)
  if (diffMin < 1) return t('support.beacon.relative_time.now')
  if (diffMin < 60) return t('support.beacon.relative_time.minutes_ago', { count: diffMin })
  const diffHour = Math.round(diffMin / 60)
  if (diffHour < 24) return t('support.beacon.relative_time.hours_ago', { count: diffHour })
  const diffDay = Math.round(diffHour / 24)
  return t('support.beacon.relative_time.days_ago', { count: diffDay })
}

